import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useProfile from "./useProfile";
import { isRoleCOCO } from "../utils/utils";
import useCustomRouting from "./useCustomRouting";

const useHideSidebar = (path) => {
  const { tokenData } = useProfile();
  const { redirectToPath } = useCustomRouting();

  const roles = tokenData?.roles;
  const [hideSideBar, setHideSideBar] = useState(false);
  const { loading: status, controllers } = useSelector(
    (state) => state.controllers
  );
  const controllersLoaded = ["succeeded", "failed"]?.includes(status);
  useEffect(() => {
    if (path?.includes("/ui/access-denied")) {
      setHideSideBar(true);
    } else setHideSideBar(false);
  }, [path]);

  useEffect(() => {
    if (
      roles &&
      controllersLoaded &&
      controllers?.length === 0 &&
      !isRoleCOCO(roles)
    )
      redirectToPath("/access-denied");
  }, [controllersLoaded, roles]);
  return {
    hideSideBar,
  };
};

export default useHideSidebar;
